import { blogPostsLocales, guidesLocales } from '@/config/locales';
import { PAGE_SIZE } from '@/config/strapi-content';
import { mapApiDataToNews } from '@/lib/cms-mappers';

import type { FNewsTemplateProps } from '@/components/templates/FNewsTemplate.vue';

/**
 * Returns news data fetched from CMS (Strapi)
 */
export async function useCmsNews(): UseCmsResponse<FNewsTemplateProps> {
  const { t } = useI18n();

  const blogPosts = useStrapi('blog-posts', {
    localesSubset: blogPostsLocales,
    queryParams: {
      populate: ['main_image'],
      filters: {
        company_news: true,
      },
      sort: { published_at_override: 'desc', publishedAt: 'desc' },
      pagination: {
        page: 0,
        pageSize: PAGE_SIZE,
      },
    },
  });

  const guides = useStrapi('guides', {
    localesSubset: guidesLocales,
    queryParams: {
      populate: '*',
      pagination: {
        page: 0,
        pageSize: PAGE_SIZE,
      },
    },
  });

  const [{ data: blogPostsData }, { data: guidesData }] = await Promise.all([
    blogPosts,
    guides,
  ]);

  const mappedData = computed(() =>
    mapApiDataToNews(blogPostsData.value?.data, guidesData.value?.data)
  );
  const i18nMappedData = computed<FNewsTemplateProps>(() => ({
    ...mappedData.value,
    blogPostCards: mappedData.value.blogPostCards.map(card => ({
      ...card,
      linkText: t('news__related_posts__cards__button_text'),
    })),
  }));

  return { data: i18nMappedData };
}
